import LoaderContainer from './LoaderContainer';

const Loader = {
  install(Vue) {
    Vue.component('loader-container', LoaderContainer);

    this.container = undefined;

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$loader = {
      setContainer(container) {
        if (Loader.container === undefined) {
          Loader.container = container;
        } else {
          // eslint-disable-next-line no-console
          console.warn('Loader component set more than once.');
        }
      },
      show() {
        if (Loader.container) {
          Loader.container.show();
        } else {
          throw new Error('You must put a <loader-container /> somewhere in your template.');
        }
      },
      hide() {
        if (Loader.container) {
          Loader.container.hide();
        } else {
          throw new Error('You must put a <loader-container /> somewhere in your template.');
        }
      },
    };
  },
};

export default Loader;
